import { AnswerChoice } from "../types/answerChoice";

type Order = Pick<AnswerChoice, "order">;
export const sortByOrder = (a: Order, b: Order) => (a.order > b.order ? 1 : -1);
